import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import actionCreators from 'actions/creators';
import classNames from "classnames";
import CupoyRouter from "components/commons/router/CupoyRouter";

class CheckPrizeView extends Component {

    constructor(props) {
        super(props);

        this.handleSubmit = this
            .handleSubmit
            .bind(this);

        this.state = {
            upldfile: '',
            isLoading: false,
            isError: false,
            isNoFile: false,
            isFileInputReload: false,
        }
    }

    onInputChange(fieldname, event) {
        this.setState({[fieldname]: event.target.value})
    }

    onInputFileChange(fieldname, event) {

        var file = event.target.files[0];

        // 檢查檔名是不是 A_15820097 開頭，不是不給上傳
        var filename = file.name;
        if(filename.indexOf('A_15820097') !== 0) {
            this.props.webActions.openAlartDialog({
                title: '檔案錯誤',
                description: '請上傳「財政部電子發票整合服務平台」中下載的清冊Ａ檔（檔名為Ａ開頭）'
            });
            this.setState({
                isFileInputReload: true,
            }, () => {
                this.setState({
                    isFileInputReload: false,
                });
            });
            return;
        }

        this.setState({[fieldname]: event.target.files[0]})
    }


    handleSubmit(event) {

        event.preventDefault();

        if (this.state.isLoading) {
            return;
        }

        this.setState({
            isLoading: true,
            isError: false,
            isNoFile: false,
        }, () => {
            if(!this.state.upldfile) {
                this.setState({
                    isLoading: false,
                    isNoFile: true,
                });
                return;
            }

            this.props.prizedInvoiceActions.checkPrizedInvoice({
                upldfile: this.state.upldfile,
            }).then((result) => {

                if (result) {
                    this.props.webActions.cupoyStateGo(CupoyRouter.STATES.PRIZEDINVOICE_LIST, {page: 1});
                } else {
                    this.setState({
                        isError: true,
                        isLoading: false
                    });
                }

            }, (error) => {

                this.setState({
                    isError: true,
                    isLoading: false
                });
            });
        });
    }

    render() {

        // const match = this.props.match;

        return (

            <div id="EmptyInvoice">

                <div className="header-bar mix">
                    <ul className="bread-crumbs">
                        <li className="crumb-item active">
                            <a>發票對獎</a>
                        </li>
                    </ul>

                    <div className="button-group">

                        {this.state.isError ?
                            <span className="error">發生無法處理的錯誤，請聯絡工程師</span>
                            :
                            null
                        }
                        <a className="button blue" onClick={this.handleSubmit}>
                            {this.state.isLoading
                                ? <i className="zmdi zmdi-spinner animate-spinner"></i>
                                : null}
                            上傳對獎清冊
                        </a>
                    </div>
                </div>
                <div className="scroll-content">
                    <div className="form">
                        <div className="block-form none-box-shadow">
                            <div className="block-form-row">
                                <div 
                                    className={classNames("block-form-col", {
                                       'error': this.state.isNoFile
                                    })}
                                >
                                    <h5 className="title">上傳電子發票對獎清冊A檔</h5>
                                    <div className="description">
                                        {this.state.isFileInputReload ?
                                            null
                                            :
                                            <label className="button gray button-outline upload">
                                                <input
                                                    type="file"
                                                    accept="text/plain"
                                                    multiple={false}
                                                    onChange={(event) => this.onInputFileChange('upldfile', event)}/>
                                                選擇檔案
                                            </label>
                                        }
                                        {this.state.upldfile ?
                                            <span>{this.state.upldfile.name}</span>
                                            :
                                            <span>尚未選擇任何檔案</span>    
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>        
                    </div>
                </div>
            </div>
        );
    }

}

// const mapStateToProps = function(state) {     return {         history:
// state.web.history,         // showLoginDialog: state.web.showLoginDialog
// }; };

const mapActionToProps = function (dispatch) {
    return {
        prizedInvoiceActions: bindActionCreators(actionCreators.prizedInvoiceActionCreators, dispatch),
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch)
    };
};

export default connect(undefined, mapActionToProps, null, {withRef: true})(CheckPrizeView);


// WEBPACK FOOTER //
// ./src/components/prizecheck/CheckPrizeView.jsx